export enum PURCHASE_TERMS_CONDITION_DATA{
  PATH='/purchase-terms-and-conditions',
  TITLE='Purchase Terms and Conditions',
  TEMPLATE='PID-24-Purchase Terms and Conditions'
 }